import React from 'react';
import { Flex, Button } from '@chakra-ui/react';
import DownloadBTN from '../components/DownloadBTN';
import { PiPlusBold } from "react-icons/pi";

const CreateAndDownLoad = ({ 
  onClick, 
  createText, 
  btn_Text, 
  btn_Text_color,
  onDownload, // Add this prop
  isDownloading, // Optional: for loading state
  disabled // Optional: for disabled state
}) => {
  return (
    <Flex alignItems={'center'} gap={5} flexDirection={['column', 'row', 'row']}>
      <Button 
        borderRadius={"3px"} 
        bg={"brand.primary"} 
        leftIcon={<PiPlusBold />} 
        color="white"
        onClick={onClick} 
        px={9} 
        _hover={{ backgroundColor: '' }} 
        size={'lg'}
        isDisabled={isDownloading || disabled}
      >
        {createText}
      </Button>
      <DownloadBTN 
        btn_Text={btn_Text} 
        btn_Text_color={btn_Text_color} 
        onDownload={onDownload} // Pass the download handler
        isDownloading={isDownloading}
        disabled={disabled}
      />
    </Flex>
  )
}

export default CreateAndDownLoad;